<template>
  <section
    class="component-fd7c0f94"
    resmed-component-name="callout_30/70_icon-line_info_text_link"
  >
    <div
      class="component transition-in-view"
      v-bind:class="{ 'has-background': acf.layout['background'] }"
      v-bind:style="{
        background: acf.layout['background'],
      }"
    >
      <div class="container">
        <div
          class="row align-items-center justify-content-center"
          v-bind:class="[
            `-placement-${acf['box-a']['placement'].toLowerCase()}`,
          ]"
        >
          <div
            class="col-xl-5 px-xl-0 -in-view-slide-fade-lr"
            style="z-index: 1"
            v-if="acf['box-a'].question !== '' && acf['box-a'].answer !== ''"
          >
            <div
              class="box-a"
              v-bind:class="[
                `-background-color-${acf['box-a'][
                  'background-color'
                ].toLowerCase()}`,
              ]"
              v-bind:style="style"
            >
              <h5>{{ acf["box-a"].question }}</h5>
              <h2 v-html="acf['box-a'].answer"></h2>
            </div>
          </div>
          <div
            class="col-xl-7 px-xl-0 -in-view-slide-fade-lr"
            v-if="acf['box-b'].question !== '' && acf['box-b'].answer !== ''"
          >
            <div class="box-b">
              <div class="wrapper">
                <eyebrow-icon
                  v-if="acf['box-b'].eyebrowicon"
                  v-bind:eyebrowicon="acf['box-b'].eyebrowicon"
                ></eyebrow-icon>
                <h4>{{ acf["box-b"].question }}</h4>
                <div v-html="acf['box-b'].answer">
                  <!--  -->
                </div>
                <div class="call-to-action mt-3" v-if="acf.cta.href">
                  <a
                    v-bind:href="acf.cta.href"
                    v-bind:target="acf.cta.target"
                    class="btn cta-plain text-red icon right-arrow"
                    >{{ acf.cta.text }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-fd7c0f94", // callout_30/70_icon-line_info_text_link
  props: ["acf"],
  data() {
    return {
      style: {},
    };
  },
  created() {
    let hex = this.acf["box-a"]["hex-color"];

    if (hex && this.acf["box-a"]["background-color"] === "Other") {
      this.style["background-color"] = hex;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-fd7c0f94 {
  // typography exception
  // --> start
  h2 {
    margin-bottom: 0;

    font-size: 1.875rem;
    line-height: 1.4;

    @media (min-width: 1200px) {
      font-size: 2rem;
      line-height: 1.3;
    }

    span {
      position: relative;
    }
  }
  // --> end
}

.component {
  h4 {
    position: relative;
    margin-bottom: 0.25rem;

    &:before {
      content: "";
      position: absolute;
      top: -1.25rem;
      left: 0;
      width: 1.25rem;
      height: 3px;
      background-color: $cc-resmed-black;
    }

    @media (min-width: 768px) {
      margin-bottom: 0.75rem;
    }
  }

  h5 {
    margin-bottom: 1.5rem;
  }

  @media (min-width: 1200px) {
    [class*="-placement"] {
      padding: 0 10px;
    }

    // placement right
    .-placement-right {
      > :first-child {
        order: 1;
      }
    }
  }

  > .container {
    margin-bottom: -4rem;
    transform: translateY(-50px);

    @media (min-width: 768px) {
      transform: translateY(-50px);
    }

    @media (min-width: 1200px) {
      transform: translateY(-122px);
    }
  }

  &.has-background {
    > .container {
      margin-bottom: 0;

      @media (min-width: 1200px) {
        margin-bottom: -60px;
      }
    }
  }

  [class*="box-"] {
    border-radius: 8px;
    box-shadow: 0 0 3rem 0 rgba(0, 0, 0, 0.15);
    // box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.125);

    &.-background-color-purple {
      background-color: $cc-resmed-sa-purple;
    }

    &.-background-color-blue {
      background-color: $cc-resmed-hero-blue;
    }

    &.-background-color-red {
      background-color: $cc-resmed-action-red;
    }
  }

  .box-a {
    padding: 3rem;

    @media (min-width: 768px) {
      padding: 3rem 4rem;
    }

    * {
      color: $cc-resmed-white;
    }

    @media (min-width: 768px) {
      padding: 3rem 4rem;
    }

    @media (min-width: 1200px) {
      // padding: 3.5rem 3rem 3.875rem 3rem;
      padding: 3.5rem 4rem 3.875rem 5rem;
    }

    @media (max-width: 1199px) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .box-b {
    padding: 4rem 3rem;
    background-color: $cc-resmed-white;

    @media (min-width: 768px) {
      padding: 4rem 3.5rem;
    }

    @media (max-width: 1200px) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    // @media (min-width: 768px) and (max-width: 1199px) {
    //     border-top-left-radius: 0;
    //     border-top-right-radius: 0;
    // }
  }

  // left
  .-placement-left {
    .box-b {
      @media (min-width: 1200px) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  // right
  .-placement-right {
    .box-b {
      @media (min-width: 1200px) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}
</style>